import { IconButton } from 'components/IconButton/IconButton'
import Styles from './SavedDrafts.module.scss'
import React from 'react'
import { TextChannelKey } from 'types'
import { getChannelInfo, getChannelKeyFromTextOrDesignChannel } from 'utils/wizards'
import { Trash2 } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'
import dayjs from 'dayjs'
import { useDeleteWizardDraft } from 'hooks/queries/wizardDrafts/useDeleteWizardDraft'
import { ContentType } from 'components/ContentType/ContentType'
import { ActionsProps } from 'components/Wizards/Types'
import { WizardDraft } from 'api/clients/WizardDraftClient'
import { AspectRatioKey } from 'components/NewFileModal/Types'
import { PressProps } from '@react-aria/interactions'

interface SavedDraftProps extends PressProps {
  draft: WizardDraft
  channelKey: TextChannelKey | AspectRatioKey
}

export const SavedDraft = ({ draft, channelKey, onPress }: SavedDraftProps): React.ReactElement => {
  const channelInfo = getChannelInfo(channelKey)
  const deleteWizardDraftMutation = useDeleteWizardDraft()

  return (
    <>
      <div className={Styles.savedDraft} onClick={onPress as () => {}}>
        <div className={Styles.left}>
          <div className={Styles.image}>
            <img src={channelInfo.image} alt=""></img>
          </div>
          <div className={Styles.channel} onClick={() => {}}>
            <Text variant="largeList">{channelInfo.name}</Text>
          </div>
        </div>
        <div className={Styles.right}>
          <div className={Styles.date}>
            <Text variant="secondary">{dayjs(draft.updated_at).format('h:mma MMM D, YYYY')}</Text>
          </div>
          <div className={Styles.actions}>
            <IconButton
              data-testid="delete-draft"
              onPress={() => {
                deleteWizardDraftMutation.mutate(draft)
              }}
            >
              <Trash2 />
            </IconButton>
          </div>
        </div>
      </div>
      <div className={Styles.divider} />
    </>
  )
}

interface SavedDraftsProps extends ActionsProps {
  wizardDrafts: WizardDraft[]
}

export const SavedDrafts = ({ wizardDrafts, initialValues, ...rest }: SavedDraftsProps): React.ReactElement => {
  return (
    <div className={Styles.savedDraftsContainer}>
      {wizardDrafts.map((draft) => {
        const channelKey = getChannelKeyFromTextOrDesignChannel(
          draft.channel as TextChannelKey,
          draft.values?.width ?? 0,
          draft.values?.height ?? 0,
        )
        return (
          <ContentType
            key={draft.id}
            type={channelKey}
            initialValues={{ ...initialValues, ...draft.values }}
            initialStep={draft.step}
            initialCompletedAll={draft.completed_all}
            {...rest}
          >
            <SavedDraft draft={draft} channelKey={channelKey} />
          </ContentType>
        )
      })}
    </div>
  )
}
